/*
*###############################################################################
*Module Name                   : DPSearchBox.js                                #
*Purpose of the Module         : Search ModalUI                                #
*Description of the Module     : Common Search Modal Component with Table      #
*Original Author               :  T A C Priyashad                              #
*Date                          : Sunday, August 22nd 2021, 7:35:18 am          #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/
import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { Row, Col, Card, CardBody, CardTitle, Button, Modal } from "reactstrap"
import DPSwitch from "./DPSwitch";

const DPMultiplePricePopUp = (props) => {

    const [selectedRowIndex, setSelectedRowIndex] = useState(0);

    useEffect(() => {
        setSelectedRowIndex(0)
    }, [props.isOpen]);

    const handleKeyDown = (event) => {
        if (event.key === "ArrowUp") {
            event.preventDefault();
            navigateUp();
        } else if (event.key === "ArrowDown") {
            event.preventDefault();
            navigateDown();
        } else if (event.key === "Enter") {
            props.onRowClick(event, props.data[selectedRowIndex])
        }
    };

    const navigateUp = () => {
        setSelectedRowIndex((prevIndex) =>
            prevIndex !== null && prevIndex > 0 ? prevIndex - 1 : 0
        );
    };

    const navigateDown = () => {
        setSelectedRowIndex((prevIndex) =>
            prevIndex !== null && prevIndex < props.data.length - 1
                ? prevIndex + 1
                : props.data.length - 1
        );
    };



    return (
        <div onKeyDown={handleKeyDown}>
            <Modal
                size="md"
                isOpen={props.isOpen}
                toggle={props.toggle}
            >
                <div className="modal-header">
                    <h5
                        className="modal-title mt-0"
                        id="myExtraLargeModalLabel"
                    >
                        {props.mainTitle}
                    </h5>
                    <button
                        onClick={props.toggle}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <table className="table table-bordered table-centered table-hover table-sm">
                        <thead className="table-light">
                            <tr>
                                <th>Item Code</th>
                                <th>Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.data.map((item, index) => {
                                return (
                                    <tr key={index} onClick={(e) => {
                                        props.onRowClick(e, item)

                                    }}
                                        style={{ background: selectedRowIndex === index ? "lightgray" : "" }}
                                    >
                                        <td>{item.product}</td>
                                        <td>{parseFloat(item.selling).toFixed(props.txnDecimalAmt)}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </Modal>
        </div>
    );
}

export default DPMultiplePricePopUp;